import { httpRequest } from './http';
import { endpoint, SERVICE_KEYS } from './config';

/**
 * On the first idle tick after the session bootstraps, wake every service this
 * console consumes so the next operator-facing request does not pay the
 * cold-start tax.
 *
 * Failures are silently swallowed: a warmup never blocks a render and never
 * affects circuit-breaker state for real traffic. The route is unauthenticated
 * by contract, so it can fire before a session exists.
 */
export function warmupServices(): void {
  const run = () => {
    for (const service of SERVICE_KEYS) {
      void httpRequest(endpoint(service, '/warmup'), { method: 'GET' }).catch(() => undefined);
    }
  };

  // `typeof …` rather than `'requestIdleCallback' in window`: the property is
  // declared on `Window`, so the `in` check narrows the else branch to `never`
  // and every call on it stops compiling. A runtime capability check has to ask
  // about the value, not about the type's shape.
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run);
  } else {
    window.setTimeout(run, 0);
  }
}
